import { render } from "./CustomRouteWrapperComponent.vue?vue&type=template&id=581ef554&ts=true"
import script from "./CustomRouteWrapperComponent.vue?vue&type=script&lang=ts"
export * from "./CustomRouteWrapperComponent.vue?vue&type=script&lang=ts"

import "./CustomRouteWrapperComponent.vue?vue&type=style&index=0&id=581ef554&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__